import { useEffect, useState } from "react";
import { FaChalkboardTeacher } from "react-icons/fa";
import { MdArrowBack, MdEdit, MdEmail, MdFormatQuote, MdLocationCity, MdLocationOn, MdMenuBook, MdOutlineSchool, MdPayment, MdPerson, MdPersonPinCircle, MdPhone, MdPriceChange, MdSchool, MdVideoCameraBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import { setDate } from "rsuite/esm/internals/utils/date";
import { useMediaQuery } from "react-responsive";
import { web_url } from "../../constant";

const url = "https://20.205.136.23/api/";
function ResearcherManageData1({ t }) {
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });
    const navigate = useNavigate();

    const [details, setDetails] = useState({
        district: '',
        school: '',
        teacherWithClass: '',
    })

    const [detailsFinal, setDetailsFinal] = useState({
        district: "",
        school: "",
        teacherWithClass: "",
    })


    const [errors, setErrors] = useState(
        {
            noDistrict: false,
            noSchool: false,
            noTeacherWithClass: false,
            noStudent: false
        }
    )

    const [isTeacher, setIsTeacher] = useState(false);

    const [districtSchoolList, setDistrictSchoolList] = useState([])

    const [districtOptionsTeachers, setDistrictOptionsTeachers] = useState(districtSchoolList.map(district => ({
        value: district.district,
        label: district.district,
    }))
    )

    const [districtOptionsStudents, setDistrictOptionsStudents] = useState(
        districtSchoolList
            .filter(district =>
                district.schools.some(school =>
                    school.teachers.some(teacher =>
                        teacher.students.length > 0
                    )
                )
            )
            .map(district => ({
                value: district.district,
                label: district.district,
            }))
    );

    useEffect(() => {
        localStorage.removeItem('mailsent');
        localStorage.removeItem('mailreceived');
        localStorage.removeItem('folder')
        localStorage.removeItem('nowreading')
        setDistrictOptionsTeachers(
            districtSchoolList.map(district => ({
                value: district.district,
                label: district.district,
            }))
        )
    }, [districtSchoolList])

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (!logDetails?.email) {
            console.log("No user details found");
            setIsLoading(false);
            return;
        }
        setDistrictOptionsStudents(
            districtSchoolList
                .filter(district =>
                    district.schools.some(school =>
                        school.teachers.some(teacher =>
                            teacher.students.length > 0
                        )
                    )
                )
                .map(district => ({
                    value: district.district,
                    label: district.district,
                }))
        )
        console.log('dis', districtOptionsStudents);

    }, [districtSchoolList])


    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [schoolOptions, setSchoolOptions] = useState([]);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [teacherOptions, setTeacherOptions] = useState([]);

    const handleChangeDistrict = (selectedOption) => {
        setDetails((prev) => ({
            ...prev, district: selectedOption, school: '', teacherWithClass: ''
        }));
        setDetailsFinal((prev) => ({
            ...prev, district: selectedOption.value, school: '', teacherWithClass: ''
        }));

        setSelectedDistrict(selectedOption);
        setSelectedSchool(null);
        setTeacherOptions([]);
        setSchoolOptions([]);

        if (!isTeacher) {
            let schools = districtSchoolList.find(d => d.district === selectedOption.value)?.schools || [];
            // Filter only schools that have at least one student
            schools = schools.filter(school =>
                school.teachers.some(teacher => teacher.students.length > 0)
            );
            setSchoolOptions(schools.map(school => ({ value: school.school, label: school.school })));
        } else {
            let schools = districtSchoolList.find(d => d.district === selectedOption.value)?.schools || [];
            setSchoolOptions(schools.map(school => ({ value: school.school, label: school.school })));
            // setSchoolOptions([]);
        }

    };

    const handleChangeSchool = (selectedOption) => {
        setDetails(prev => ({ ...prev, school: selectedOption, teacherWithClass: '' }));
        setDetailsFinal(prev => ({ ...prev, school: selectedOption.value, teacherWithClass: '' }));
        setSelectedSchool(selectedOption);
        setTeacherOptions([]);
        // Find the selected district and school
        const selectedSchool = districtSchoolList
            .find(d => d.district === selectedDistrict?.value)?.schools
            .find(s => s.school === selectedOption?.value);

        if (!selectedSchool) {
            setTeacherOptions([]);
            return;
        }

        let teachers = selectedSchool.teachers || [];

        if (!isTeacher) {
            // Filter only teachers who have students
            teachers = teachers.filter(teacher => teacher.students.length > 0);
        }

        setTeacherOptions(teachers.map(teacher => ({
            value: teacher.teacherName,
            label: teacher.teacherName
        })));
    };


    const handleChangeTeacher = (selected) => {
        setDetails((prev) => ({
            ...prev, teacherWithClass: selected
        }))
        setDetailsFinal((prev) => ({
            ...prev, teacherWithClass: selected.value
        }))
    };

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setIsLoading(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            const apiUrl = `${web_url}/api/auth/teachers/structure/optimized?userRole=STUDENT`

            // axios.post(apiUrl, researcher, config)
            axios.get(apiUrl, configToken)
                .then((response) => {
                    try {
                        const list = response.data;
                        setDistrictSchoolList(list)
                        // console.log("districtSchoolList retireved");
                    } catch {
                        setDistrictSchoolList([])
                    }
                    setIsLoading(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setIsLoading(false);
                });
        }
    }, [])

    const handleContinue = () => {

        let newErrors = {};

        newErrors.noDistrict = !detailsFinal.district;
        newErrors.noSchool = !detailsFinal.school;

        if (isTeacher) {
            newErrors.noTeacherWithClass = false;
        } else {
            newErrors.noTeacherWithClass = !detailsFinal.teacherWithClass;
        }

        setErrors(newErrors);

        if (newErrors.noDistrict && newErrors.noSchool && newErrors.noTeacherWithClass) {
            return
        }
        // console.log(detailsFinal);
        if (isTeacher) {
            searchTeacherData();
        } else {
            searchStudentData();
        }

    }

    const [teacherList, setTeacherList] = useState([])
    const [studentList, setStudentList] = useState([])

    const [isLoadingList, setIsLoadingList] = useState(false)

    const [detailsSearchStudent, setDetailsSearchStudent] = useState({})

    const searchTeacherData = () => {
        if (detailsFinal.district && detailsFinal.school) {
            // console.log("thi is run 1");

            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();
            if (logDetails) {
                setIsLoadingList(true);
                const detailsSearch = {
                    district: detailsFinal.district,
                    school: detailsFinal.school
                };

                const apiUrl = `${url}auth/teachers/filter`
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${logDetails.token}`,
                    },
                };

                // axios.post(apiUrl, researcher, config)
                axios.post(`${web_url}/api/auth/teachers/filter`, detailsSearch, config)
                    .then((response) => {
                        // console.log(response.data);
                        setTeacherList(response.data)
                        setIsLoadingList(false);
                    })
                    .catch((err) => {
                        console.log("error occured");
                        setIsLoadingList(false);
                    });
            }

        } else if (detailsFinal.district === "" && detailsFinal.school) {
            // console.log("thi is run 2");
            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();
            if (logDetails) {
                setIsLoadingList(true);
                const detailsSearch = {
                    school: detailsFinal.school
                };

                const apiUrl = `${url}auth/teachers/filter`
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${logDetails.token}`
                    },
                };

                // axios.post(apiUrl, researcher, config)
                axios.post(`${web_url}/api/auth/teachers/filter`, detailsSearch, config)
                    .then((response) => {
                        setTeacherList(response.data)
                        setIsLoadingList(false);
                    })
                    .catch((err) => {
                        console.log("error occured");
                        setIsLoadingList(false);
                    });
            }

        } else if (detailsFinal.district && detailsFinal.school === "") {
            // console.log("thi is run 3");
            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();
            if (logDetails) {
                setIsLoadingList(true);
                const detailsSearch = {
                    district: detailsFinal.district,
                };

                const apiUrl = `${url}auth/teachers/filter`
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${logDetails.token}`
                    },
                };

                // axios.post(apiUrl, researcher, config)
                axios.post(`${web_url}/api/auth/teachers/filter`, detailsSearch, config)
                    .then((response) => {
                        setTeacherList(response.data)

                        setIsLoadingList(false);
                    })
                    .catch((err) => {
                        console.log("error occured");
                        setIsLoadingList(false);
                    });
            }

        }

    }

    // console.log("nown", detailsSearchStudent);

    const searchStudentData = async () => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const logDetails = getLogDetails();
        if (!logDetails) return;

        setIsLoadingList(true);

        let searchParams = {};

        if (detailsFinal.district) searchParams.district = detailsFinal.district;
        if (detailsFinal.school) searchParams.school = detailsFinal.school;
        if (detailsFinal.teacherWithClass) searchParams.teacherName = detailsFinal.teacherWithClass;

        setDetailsSearchStudent(searchParams);

        try {

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };
            const apiUrl = `${url}auth/teachers/filter`;
            const config = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${logDetails.token}` } };

            await new Promise(resolve => setTimeout(resolve, 0));

            const response = await axios.post(`${web_url}/api/auth/students/filter`, searchParams, config);
            const filteredStudents = response.data.filter((student) => student.accountStatus !== "PENDING")

            setStudentList(filteredStudents);
        } catch (error) {
            console.error("Error occurred");
        } finally {
            setIsLoadingList(false);
        }
    };

    const [searchInputStudent, setSearchInputStudent] = useState("");
    const [searchInputTeacher, setSearchInputTeacher] = useState("");

    const [filteredStudents, setFilteredStudents] = useState(() => studentList.filter((student) =>
        student.userFullName.toLowerCase().includes(searchInputStudent.toLowerCase())
    ))
    const [filteredTeachers, setFilteredTeachers] = useState(() => teacherList.filter((teacher) =>
        teacher.userFullName.toLowerCase().includes(searchInputTeacher.toLowerCase())
    ))

    useEffect(() => {
        let tempFilteredStudents = studentList;

        // Apply search filter
        if (searchInputStudent.trim() !== '') {
            tempFilteredStudents = tempFilteredStudents.filter((student) =>
                student.userFullName.toLowerCase().includes(searchInputStudent.toLowerCase())
            );
        }

        setFilteredStudents(tempFilteredStudents);
        // console.log(filteredStudents);

    }, [searchInputStudent, studentList]);

    useEffect(() => {
        let tempFilteredTeacher = teacherList;

        // Apply search filter
        if (searchInputTeacher.trim() !== '') {
            tempFilteredTeacher = tempFilteredTeacher.filter((teacher) =>
                teacher.userFullName.toLowerCase().includes(searchInputTeacher.toLowerCase())
            );
        }

        setFilteredTeachers(tempFilteredTeacher);
        // console.log(filteredStudents);

    }, [searchInputTeacher, teacherList]);


    useEffect(() => {
        localStorage.removeItem("userSelected")
    }, [])

    const handleStatusStudent = (studentEmail, newStatus) => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (!logDetails) return;

        setIsLoadingList(true);

        const config = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${logDetails.token}` } };

        axios.put(`${web_url}/api/auth/students/${studentEmail}/account-status?status=${newStatus.toUpperCase()}`, {}, config)
            .then((response) => {
                filteredStudents.forEach((student) => {
                    if (student.userEmail === studentEmail) {
                        student.accountStatus = newStatus.toUpperCase();
                    }
                });
                setIsLoadingList(false);
            })
            .catch((err) => {
                console.log("error occured", err);

                setIsLoadingList(false);
            });
    }

    return (
        <div className={`pl-[30px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]`}>
            <div className="flex items-center justify-start mt-[20px] lg:ml-[70px]">
                <MdArrowBack size={25} className="md:hidden" onClick={() => {
                    navigate('/mobile/researcher/dashboard')
                }} />
                <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                    navigate('/mobile/researcher/dashboard')
                }} />
                <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                    navigate('/desktop/researcher/dashboard')
                }} />
                <p className=" font-bold text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px]">{t('t191')}</p>
            </div>

            {
                isLoading ?
                    <div className="items-center justify-center flex pt-[30px]">
                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                    </div>
                    :
                    <>
                        <div className=" flex justify-center mt-[20px] md:mt-[20px] lg:mt-[30px] xl:mt-[20px] xl:mb-[20px] 2xl:mt-[30px] ">
                            <div className="w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] flex justify-center gap-[30px]">
                                <button onClick={() => {
                                    setIsTeacher(true);
                                    setDetails(
                                        { district: '', school: '', teacherWithClass: '' }
                                    )
                                    setDetailsFinal(
                                        { district: '', school: '', teacherWithClass: '' }
                                    )
                                    setStudentList([])
                                    setTeacherList([])
                                    setSelectedSchool(null);
                                    setTeacherOptions([]);
                                    setSchoolOptions([]);
                                }
                                } className={`w-[45%] border border-[#F2AC0E] ${isTeacher ? 'bg-[#F2AC0E] bg-opacity-100' : 'bg-[#F2AC0E] bg-opacity-20'} text-black px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px]  rounded-md`}>{t('t3')}</button>
                                <button onClick={() => {
                                    setIsTeacher(false);
                                    setDetails(
                                        { district: '', school: '', teacherWithClass: '' }
                                    )
                                    setDetailsFinal(
                                        { district: '', school: '', teacherWithClass: '' }
                                    )
                                    setStudentList([])
                                    setTeacherList([])
                                    setSelectedSchool(null);
                                    setTeacherOptions([]);
                                    setSchoolOptions([]);
                                }} className={`w-[45%] border border-[#F2AC0E] ${!isTeacher ? 'bg-[#F2AC0E] bg-opacity-100' : 'bg-[#F2AC0E] bg-opacity-20'} text-black px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px] rounded-md`}>{t('t4')}</button>
                            </div>
                        </div>
                        {/* <div className="lg:ml-[180px] md:ml-[100px] xl:ml-[100px] 2xl:ml-[150px] items-center mt-[30px] xl:mt-[10px] 2xl:mt-[50px] flex rounded-md w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400"> */}
                        <div className="xl:hidden flex flex-col items-center justify-center">
                            {
                                !isTeacher ?
                                    <>
                                        <div className="items-center mt-[30px] xl:mt-[10px] 2xl:mt-[20px] flex rounded-md w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                            <MdLocationOn size="24px" color="#8189B0" />
                                            <Select
                                                options={districtOptionsStudents}
                                                value={details.district}
                                                onChange={handleChangeDistrict}
                                                noOptionsMessage={() => t('t209')}
                                                placeholder={t('t198')}
                                                isSearchable
                                                styles={{
                                                    control: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: "#F1F6FB",
                                                        borderColor: "transparent",
                                                        boxShadow: "none",
                                                        "&:hover": {
                                                            borderColor: "transparent",
                                                        },
                                                    }),
                                                    menu: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: "#F1F6FB",
                                                    }),
                                                    option: (baseStyles, { isFocused, isSelected }) => ({
                                                        ...baseStyles,
                                                        backgroundColor: isSelected
                                                            ? "#ccc"
                                                            : isFocused
                                                                ? "#F1F6FB"
                                                                : "#F1F6FB",
                                                        color: "#000",
                                                    }),
                                                }}
                                                className="w-full"
                                            />
                                        </div>

                                        <div className="items-center mt-[30px] xl:mt-[10px] 2xl:mt-[50px] flex rounded-md w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                            <MdSchool size="24px" color="#8189B0" />
                                            <Select
                                                options={schoolOptions}
                                                value={details.school}
                                                onChange={handleChangeSchool}
                                                placeholder={t('t199')}
                                                noOptionsMessage={() => t('t201')}
                                                isSearchable
                                                styles={{
                                                    control: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: "#F1F6FB",
                                                        borderColor: "transparent",
                                                        boxShadow: "none",
                                                        "&:hover": {
                                                            borderColor: "transparent",
                                                        },
                                                    }),
                                                    menu: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: "#F1F6FB",
                                                    }),
                                                    option: (baseStyles, { isFocused, isSelected }) => ({
                                                        ...baseStyles,
                                                        backgroundColor: isSelected
                                                            ? "#ccc"
                                                            : isFocused
                                                                ? "#F1F6FB"
                                                                : "#F1F6FB",
                                                        color: "#000",
                                                    }),
                                                }}
                                                className="w-full"
                                            />
                                        </div>

                                        <div className="items-center mt-[30px] xl:mt-[10px] 2xl:mt-[50px] flex rounded-md w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                            <FaChalkboardTeacher size="24px" color="#8189B0" />
                                            <Select
                                                options={teacherOptions}
                                                value={details.teacherWithClass}
                                                onChange={handleChangeTeacher}
                                                placeholder={t('t200')}
                                                noOptionsMessage={() => t('t202')}
                                                isSearchable
                                                styles={{
                                                    control: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: "#F1F6FB",
                                                        borderColor: "transparent",
                                                        boxShadow: "none",
                                                        "&:hover": {
                                                            borderColor: "transparent",
                                                        },
                                                    }),
                                                    menu: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: "#F1F6FB",
                                                    }),
                                                    option: (baseStyles, { isFocused, isSelected }) => ({
                                                        ...baseStyles,
                                                        backgroundColor: isSelected
                                                            ? "#ccc"
                                                            : isFocused
                                                                ? "#F1F6FB"
                                                                : "#F1F6FB",
                                                        color: "#000",
                                                    }),
                                                }}
                                                className="w-full"
                                            />
                                        </div>
                                    </> :
                                    <>
                                        <div className="items-center mt-[30px] xl:mt-[10px] 2xl:mt-[50px] flex rounded-md w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                            <MdLocationOn size="24px" color="#8189B0" />
                                            <Select
                                                options={districtOptionsTeachers}
                                                value={details.district}
                                                onChange={handleChangeDistrict}
                                                placeholder={t('t198')}
                                                isSearchable
                                                styles={{
                                                    control: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: "#F1F6FB",
                                                        borderColor: "transparent",
                                                        boxShadow: "none",
                                                        "&:hover": {
                                                            borderColor: "transparent",
                                                        },
                                                    }),
                                                    menu: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: "#F1F6FB",
                                                    }),
                                                    option: (baseStyles, { isFocused, isSelected }) => ({
                                                        ...baseStyles,
                                                        backgroundColor: isSelected
                                                            ? "#ccc"
                                                            : isFocused
                                                                ? "#F1F6FB"
                                                                : "#F1F6FB",
                                                        color: "#000",
                                                    }),
                                                }}
                                                className="w-full"
                                            />
                                        </div>

                                        <div className="items-center mt-[30px] xl:mt-[10px] 2xl:mt-[50px] flex rounded-md w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                            <MdSchool size="24px" color="#8189B0" />
                                            <Select
                                                options={schoolOptions}
                                                value={details.school}
                                                onChange={handleChangeSchool}
                                                placeholder={t('t199')}
                                                noOptionsMessage={() => t('t201')}
                                                isSearchable
                                                styles={{
                                                    control: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: "#F1F6FB",
                                                        borderColor: "transparent",
                                                        boxShadow: "none",
                                                        "&:hover": {
                                                            borderColor: "transparent",
                                                        },
                                                    }),
                                                    menu: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: "#F1F6FB",
                                                    }),
                                                    option: (baseStyles, { isFocused, isSelected }) => ({
                                                        ...baseStyles,
                                                        backgroundColor: isSelected
                                                            ? "#ccc"
                                                            : isFocused
                                                                ? "#F1F6FB"
                                                                : "#F1F6FB",
                                                        color: "#000",
                                                    }),
                                                }}
                                                className="w-full"
                                            />
                                        </div>
                                    </>
                            }
                        </div>

                        {
                            !isTeacher ?
                                <>
                                    <div className="hidden xl:grid grid-cols-3 w-full px-[50px]">
                                        <div>
                                            <div className="w-full">
                                                <div className="items-center justify-center mt-[30px] mx-[20px] xl:mt-[10px] 2xl:mt-[50px] flex rounded-md  bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                                    <MdLocationOn size="24px" color="#8189B0" />
                                                    <Select
                                                        options={districtOptionsStudents}
                                                        value={details.district}
                                                        onChange={handleChangeDistrict}
                                                        placeholder={t('t280')}
                                                        isSearchable
                                                        styles={{
                                                            control: (baseStyles) => ({
                                                                ...baseStyles,
                                                                backgroundColor: "#F1F6FB",
                                                                borderColor: "transparent",
                                                                boxShadow: "none",
                                                                "&:hover": {
                                                                    borderColor: "transparent",
                                                                },
                                                            }),
                                                            menu: (baseStyles) => ({
                                                                ...baseStyles,
                                                                backgroundColor: "#F1F6FB",
                                                            }),
                                                            option: (baseStyles, { isFocused, isSelected }) => ({
                                                                ...baseStyles,
                                                                backgroundColor: isSelected
                                                                    ? "#ccc"
                                                                    : isFocused
                                                                        ? "#F1F6FB"
                                                                        : "#F1F6FB",
                                                                color: "#000",
                                                            }),
                                                        }}
                                                        className="w-full"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <div className="items-center mt-[30px] xl:mt-[10px] 2xl:mt-[50px] mx-[20px] flex rounded-md  bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                                <MdSchool size="24px" color="#8189B0" />
                                                <Select
                                                    options={schoolOptions}
                                                    value={details.school}
                                                    onChange={handleChangeSchool}
                                                    placeholder={t('t199')}
                                                    noOptionsMessage={() => t('t201')}
                                                    isSearchable
                                                    styles={{
                                                        control: (baseStyles) => ({
                                                            ...baseStyles,
                                                            backgroundColor: "#F1F6FB",
                                                            borderColor: "transparent",
                                                            boxShadow: "none",
                                                            "&:hover": {
                                                                borderColor: "transparent",
                                                            },
                                                        }),
                                                        menu: (baseStyles) => ({
                                                            ...baseStyles,
                                                            backgroundColor: "#F1F6FB",
                                                        }),
                                                        option: (baseStyles, { isFocused, isSelected }) => ({
                                                            ...baseStyles,
                                                            backgroundColor: isSelected
                                                                ? "#ccc"
                                                                : isFocused
                                                                    ? "#F1F6FB"
                                                                    : "#F1F6FB",
                                                            color: "#000",
                                                        }),
                                                    }}
                                                    className="w-full"
                                                />
                                            </div>

                                        </div>

                                        <div>
                                            <div className="items-center mt-[30px] xl:mt-[10px] 2xl:mt-[50px] mx-[20px] flex rounded-md  bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                                <FaChalkboardTeacher size="24px" color="#8189B0" />
                                                <Select
                                                    options={teacherOptions}
                                                    value={details.teacherWithClass}
                                                    onChange={handleChangeTeacher}
                                                    placeholder={t('t200')}
                                                    noOptionsMessage={() => t('t202')}
                                                    isSearchable
                                                    styles={{
                                                        control: (baseStyles) => ({
                                                            ...baseStyles,
                                                            backgroundColor: "#F1F6FB",
                                                            borderColor: "transparent",
                                                            boxShadow: "none",
                                                            "&:hover": {
                                                                borderColor: "transparent",
                                                            },
                                                        }),
                                                        menu: (baseStyles) => ({
                                                            ...baseStyles,
                                                            backgroundColor: "#F1F6FB",
                                                        }),
                                                        option: (baseStyles, { isFocused, isSelected }) => ({
                                                            ...baseStyles,
                                                            backgroundColor: isSelected
                                                                ? "#ccc"
                                                                : isFocused
                                                                    ? "#F1F6FB"
                                                                    : "#F1F6FB",
                                                            color: "#000",
                                                        }),
                                                    }}
                                                    className="w-full"
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </> :
                                <>
                                    <div className="hidden xl:grid grid-cols-2 w-full px-[50px]">
                                        <div>
                                            <div className="w-full">
                                                <div className="items-center justify-center mt-[30px] mx-[20px] xl:mt-[10px] 2xl:mt-[50px] flex rounded-md  bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                                    <MdLocationOn size="24px" color="#8189B0" />
                                                    <Select
                                                        options={districtOptionsTeachers}
                                                        value={details.district}
                                                        onChange={handleChangeDistrict}
                                                        placeholder={t('t198')}
                                                        isSearchable
                                                        styles={{
                                                            control: (baseStyles) => ({
                                                                ...baseStyles,
                                                                backgroundColor: "#F1F6FB",
                                                                borderColor: "transparent",
                                                                boxShadow: "none",
                                                                "&:hover": {
                                                                    borderColor: "transparent",
                                                                },
                                                            }),
                                                            menu: (baseStyles) => ({
                                                                ...baseStyles,
                                                                backgroundColor: "#F1F6FB",
                                                            }),
                                                            option: (baseStyles, { isFocused, isSelected }) => ({
                                                                ...baseStyles,
                                                                backgroundColor: isSelected
                                                                    ? "#ccc"
                                                                    : isFocused
                                                                        ? "#F1F6FB"
                                                                        : "#F1F6FB",
                                                                color: "#000",
                                                            }),
                                                        }}
                                                        className="w-full"
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                        <div>
                                            <div className="items-center mt-[30px] xl:mt-[10px] 2xl:mt-[50px] mx-[20px] flex rounded-md  bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                                <MdSchool size="24px" color="#8189B0" />
                                                <Select
                                                    options={schoolOptions}
                                                    value={details.school}
                                                    onChange={handleChangeSchool}
                                                    placeholder={t('t199')}
                                                    noOptionsMessage={() => t('t201')}
                                                    isSearchable
                                                    styles={{
                                                        control: (baseStyles) => ({
                                                            ...baseStyles,
                                                            backgroundColor: "#F1F6FB",
                                                            borderColor: "transparent",
                                                            boxShadow: "none",
                                                            "&:hover": {
                                                                borderColor: "transparent",
                                                            },
                                                        }),
                                                        menu: (baseStyles) => ({
                                                            ...baseStyles,
                                                            backgroundColor: "#F1F6FB",
                                                        }),
                                                        option: (baseStyles, { isFocused, isSelected }) => ({
                                                            ...baseStyles,
                                                            backgroundColor: isSelected
                                                                ? "#ccc"
                                                                : isFocused
                                                                    ? "#F1F6FB"
                                                                    : "#F1F6FB",
                                                            color: "#000",
                                                        }),
                                                    }}
                                                    className="w-full"
                                                />
                                            </div>

                                        </div>

                                    </div>
                                </>
                        }
                        <div className="flex w-full xl:full items-center justify-center">
                            {((errors.noSchool && errors.noDistrict && errors.noTeacherWithClass && !isTeacher) || (isTeacher && errors.noSchool && errors.noDistrict)) &&
                                <p className='text-[#ff0000] text-[12px] mt-[15px]'>{t('t203')}</p>
                            }
                        </div>
                        <div className=" flex justify-center mt-[20px] md:mt-[20px] lg:mt-[30px] xl:mt-[10px] xl:mb-[30px] 2xl:mt-[20px] ">
                            <div className="w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] flex justify-center gap-[30px]">
                                <button onClick={handleContinue} className="w-[45%] bg-[#F2AC0E] text-black px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px] rounded-md">{t('t204')}</button>
                            </div>
                        </div>

                        {
                            isLoadingList ?
                                <div className="items-center justify-center flex pt-[30px]">
                                    <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                                </div>
                                :
                                <>
                                    {
                                        !isTeacher &&
                                        <>
                                            <div className="mt-[20px] xl:mt-[0px] mx-[20px] md:mx-[100px] lg:mx-[130px] xl:mx-[250px] mb-[5px] lg:px-[80px] xl:px-[160px] xl:px-[190px]">
                                                <input
                                                    type="search"
                                                    placeholder={t('t281')}
                                                    onChange={(e) => setSearchInputStudent(e.target.value)}
                                                    value={searchInputStudent}
                                                    className="p-2 md:p-3 lg:p-4 xl:px-1 xl:py-[10px] 2xl:p-2 border border-gray-300 rounded-md w-full text-black text-[15px] md:text-[18px] xl:text-[17px]"
                                                />
                                            </div>
                                            <div className="mt-[20px] md:mt-[40px] xl:hidden pb-[100px]">
                                                {filteredStudents.length > 0 ?
                                                    <>
                                                        {
                                                            filteredStudents.map((student, index) => (
                                                                <div className="mt-[10px] md:mt-[15px] flex items-center justify-between px-[10px] ml-[5px] mr-[5px] md:ml-[80px] md:mr-[80px] lg:ml-[140px] lg:mr-[140px] bg-[#F1F6FB] py-[10px] rounded-lg border border-gray-300">
                                                                    <div className="md:hidden flex flex-col gap-[5px]">
                                                                        <p className="text-[#8189B0] text-[13px] font-bold">{student.userFullName.length > 24
                                                                            ? `${student.userFullName.slice(0, 24)}...`
                                                                            : student.userFullName}</p>
                                                                        <p className="text-[#8189B0] text-[13px] ">{student.userEmail.length > 24
                                                                            ? `${student.userEmail.slice(0, 24)}...`
                                                                            : student.userEmail}</p>
                                                                        <p className={`${student.accountStatus === "ACTIVE" ? 'text-[#F2AC0E]' : 'text-red-400'} text-[#8189B0] text-[13px] `}>{student.accountStatus}</p>
                                                                    </div>
                                                                    <div className="hidden md:flex flex-col">
                                                                        <p className="text-[#8189B0] text-[15px] font-bold">{student.userFullName.length > 35
                                                                            ? `${student.userFullName.slice(0, 45)}...`
                                                                            : student.userFullName}</p>
                                                                        <p className="text-[#8189B0] text-[15px] ">{student.userEmail.length > 35
                                                                            ? `${student.userEmail.slice(0, 45)}...`
                                                                            : student.userEmail}</p>
                                                                        <p className={`${student.accountStatus === "ACTIVE" ? 'text-[#F2AC0E]' : 'text-red-400'} text-[#8189B0] text-[15px] `}>{student.accountStatus}</p>

                                                                    </div>
                                                                    <div className="flex flex-col gap-[10px]">
                                                                        <button onClick={() => {

                                                                            const [grade, classNUmber] = student.assignedClass.split('-');
                                                                            let studentObject = {
                                                                                userEmail: student.userEmail,
                                                                                userFullName: student.userFullName,
                                                                                userRole: "STUDENT",
                                                                                school: student.school,
                                                                                district: student.district,
                                                                                assignedClass: `${student.assignedClass}`,
                                                                                dateOfBirth: student.dateOfBirth,
                                                                                penpalGroup: student.penpalGroup,
                                                                                accountStatus: student.accountStatus,
                                                                                preferredLanguage: student.preferredLanguage
                                                                            }
                                                                            localStorage.setItem("userSelected", JSON.stringify(studentObject))
                                                                            navigate('/researcher/studentprofile/view')
                                                                        }}

                                                                            className="bg-[#BBFFA3] text-black text-[13px] rounded-lg py-[4px] w-[100%]">{t('t207')}</button>

                                                                        <div className="hidden md:flex justify-center items-center mt-[5px] gap-[10px]">
                                                                            <button
                                                                                onClick={() => {
                                                                                    if (student.accountStatus !== "ACTIVE") {
                                                                                        handleStatusStudent(student.userEmail, "ACTIVE");
                                                                                    }
                                                                                }}
                                                                                className={`${student.accountStatus === "ACTIVE" ? 'bg-[#F2AC0E] bg-opacity-100' : 'bg-[#F2AC0E] bg-opacity-20'} text-black text-[12px] rounded-lg py-[4px] w-[90px] `}>ACTIVE</button>
                                                                            <button
                                                                                onClick={() => {
                                                                                    if (student.accountStatus === "ACTIVE") {
                                                                                        handleStatusStudent(student.userEmail, "INACTIVE");
                                                                                    }
                                                                                }}
                                                                                className={`${student.accountStatus === "INACTIVE" ? 'bg-[#F2AC0E] bg-opacity-100' : 'bg-[#F2AC0E] bg-opacity-20'}  text-black text-[12px] rounded-lg py-[4px] w-[90px]`}>INACTIVE</button>
                                                                        </div>
                                                                        <div className="md:hidden flex flex-col justify-center items-center mt-[5px] gap-[10px]">
                                                                            <button
                                                                                onClick={() => {
                                                                                    if (student.accountStatus !== "ACTIVE") {
                                                                                        handleStatusStudent(student.userEmail, "ACTIVE");
                                                                                    }
                                                                                }}
                                                                                className={`${student.accountStatus === "ACTIVE" ? 'bg-[#F2AC0E] bg-opacity-100' : 'bg-[#F2AC0E] bg-opacity-20'} text-black text-[12px] rounded-lg py-[4px] w-[80px] `}>ACTIVE</button>
                                                                            <button
                                                                                onClick={() => {
                                                                                    if (student.accountStatus === "ACTIVE") {
                                                                                        handleStatusStudent(student.userEmail, "INACTIVE");
                                                                                    }
                                                                                }}
                                                                                className={`${student.accountStatus === "INACTIVE" ? 'bg-[#F2AC0E] bg-opacity-100' : 'bg-[#F2AC0E] bg-opacity-20'}  text-black text-[12px] rounded-lg py-[4px] w-[80px]`}>INACTIVE</button>
                                                                        </div>
                                                                        {/* <button className="mt-[5px] bg-[#FFBEA3] text-black text-[13px] rounded-lg py-[3px] w-[110px] md:w-[130px]">Reset password</button> */}
                                                                    </div>
                                                                </div>

                                                            ))
                                                        }
                                                    </> :
                                                    <div className="mt-[10px] flex justify-center">
                                                        {
                                                            detailsFinal.district === "" && searchInputStudent.trim() !== "" &&
                                                            <p className="text-[16px] text-black">{t('t201')}</p>
                                                        }
                                                        {
                                                            detailsFinal.district !== "" && searchInputStudent.trim() !== "" &&
                                                            <p className="text-[16px] text-black">{t('t205')}</p>
                                                        }
                                                    </div>
                                                }
                                            </div>


                                            {
                                                filteredStudents.length > 0 ?
                                                    <>
                                                        <div className="mt-[10px] hidden xl:grid grid-cols-2 pb-[50px] ml-[80px] mr-[70px] gap-[20px]">
                                                            {filteredStudents.map((student, index) => (
                                                                <div key={index} className="mt-[10px] flex items-center justify-between px-[20px] ml-[10px] mr-[5px] bg-[#F1F6FB] py-[10px] rounded-lg border border-gray-300">
                                                                    <div className="2xl:hidden flex flex-col gap-[5px]">
                                                                        <p className="text-[#8189B0] text-[13px] 2xl:text-[15px] font-bold">{student.userFullName.length > 35
                                                                            ? `${student.userFullName.slice(0, 35)}...`
                                                                            : student.userFullName}</p>
                                                                        <p className="text-[#8189B0] text-[13px] 2xl:text-[15px] ">{student.userEmail.length > 35
                                                                            ? `${student.userEmail.slice(0, 35)}...`
                                                                            : student.userEmail}</p>
                                                                        <p className={`${student.accountStatus === "ACTIVE" ? 'text-[#F2AC0E]' : 'text-red-400'} text-[#8189B0] text-[13px] 2xl:text-[15px] font-bold`}>{student.accountStatus}</p>

                                                                    </div>
                                                                    <div className="hidden 2xl:flex flex-col">
                                                                        <p className="text-[#8189B0] text-[11px] 2xl:text-[15px] font-bold">{student.userFullName.length > 45
                                                                            ? `${student.userFullName.slice(0, 45)}...`
                                                                            : student.userFullName}</p>
                                                                        <p className="text-[#8189B0] text-[11px] 2xl:text-[15px] ">{student.userEmail.length > 45
                                                                            ? `${student.userEmail.slice(0, 45)}...`
                                                                            : student.userEmail}</p>
                                                                        <p className={`${student.accountStatus === "ACTIVE" ? 'text-[#F2AC0E]' : 'text-red-400'} text-[#8189B0] text-[11px] 2xl:text-[15px] font-bold`}>{student.accountStatus}</p>

                                                                    </div>
                                                                    <div className="flex flex-col gap-[10px]">
                                                                        <button
                                                                            onClick={() => {
                                                                                console.log(student);

                                                                                const [grade, classNUmber] = student.assignedClass.split('-');
                                                                                let studentObject = {
                                                                                    userEmail: student.userEmail,
                                                                                    userFullName: student.userFullName,
                                                                                    userRole: "STUDENT",
                                                                                    school: student.school,
                                                                                    district: student.district,
                                                                                    assignedClass: `${student.assignedClass}`,
                                                                                    dateOfBirth: student.dateOfBirth,
                                                                                    penpalGroup: student.penpalGroup,
                                                                                    accountStatus: student.accountStatus,
                                                                                    preferredLanguage: student.preferredLanguage
                                                                                }
                                                                                localStorage.setItem("userSelected", JSON.stringify(studentObject))
                                                                                navigate('/researcher/studentprofile/view')
                                                                            }}
                                                                            className="bg-[#BBFFA3] text-black text-[12px] rounded-lg py-[4px] w-[100%]">{t('t207')}
                                                                        </button>
                                                                        <div className="flex justify-center items-center mt-[5px] gap-[10px]">
                                                                            <button
                                                                                onClick={() => {
                                                                                    if (student.accountStatus !== "ACTIVE") {
                                                                                        handleStatusStudent(student.userEmail, "ACTIVE");
                                                                                    }
                                                                                }}
                                                                                className={`${student.accountStatus === "ACTIVE" ? 'bg-[#F2AC0E] bg-opacity-100' : 'bg-[#F2AC0E] bg-opacity-20'} text-black text-[12px] rounded-lg py-[4px] w-[90px] `}>ACTIVE</button>
                                                                            <button
                                                                                onClick={() => {
                                                                                    if (student.accountStatus === "ACTIVE") {
                                                                                        handleStatusStudent(student.userEmail, "INACTIVE");
                                                                                    }
                                                                                }}
                                                                                className={`${student.accountStatus === "INACTIVE" ? 'bg-[#F2AC0E] bg-opacity-100' : 'bg-[#F2AC0E] bg-opacity-20'}  text-black text-[12px] rounded-lg py-[4px] w-[90px]`}>INACTIVE</button>
                                                                        </div>
                                                                        {/* <button className="mt-[5px] bg-[#FFBEA3] text-black text-[13px] rounded-lg py-[3px] w-[110px]">Reset password</button> */}
                                                                    </div>
                                                                </div>

                                                            ))}
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="hidden xl:flex mt-[10px] justify-center w-full">
                                                        {
                                                            detailsFinal.district === "" && searchInputStudent.trim() !== "" &&
                                                            <p className="text-[16px] text-black">{t('t201')}</p>
                                                        }
                                                        {
                                                            detailsFinal.district !== "" && searchInputStudent.trim() !== "" &&
                                                            <p className="text-[16px] text-black">{t('t205')}</p>
                                                        }
                                                    </div>
                                            }

                                        </>
                                    }

                                    {
                                        isTeacher &&
                                        <>
                                            <div className="mt-[20px] xl:mt-[0px] mx-[20px] md:mx-[100px] lg:mx-[130px] xl:mx-[250px] mb-[5px] lg:px-[80px] xl:px-[160px] xl:px-[190px]">
                                                <input
                                                    type="search"
                                                    placeholder="Search by teacher name"
                                                    onChange={(e) => setSearchInputTeacher(e.target.value)}
                                                    value={searchInputTeacher}
                                                    className="p-2 md:p-3 lg:p-4 xl:px-1 xl:py-[10px] 2xl:p-2 border border-gray-300 rounded-md w-full text-black text-[15px] md:text-[18px] xl:text-[17px]"
                                                />
                                            </div>
                                            <div className="mt-[20px] md:mt-[40px] xl:hidden pb-[100px]">
                                                {
                                                    filteredTeachers.length > 0 ? <>
                                                        {
                                                            filteredTeachers.map((teacher, index) => (
                                                                <div className="mt-[10px] md:mt-[15px] flex items-center justify-between px-[10px] ml-[20px] mr-[10px] md:ml-[80px] md:mr-[80px] lg:ml-[140px] lg:mr-[140px] bg-[#F1F6FB] py-[10px] rounded-lg">
                                                                    <div className="md:hidden flex flex-col">
                                                                        <p className="text-[#8189B0] text-[12px] font-bold">{teacher.userFullName.length > 28
                                                                            ? `${teacher.userFullName.slice(0, 28)}...`
                                                                            : teacher.userFullName}</p>
                                                                        <p className="text-[#8189B0] text-[12px] ">{teacher.userEmail.length > 28
                                                                            ? `${teacher.userEmail.slice(0, 28)}...`
                                                                            : teacher.userEmail}</p>
                                                                    </div>
                                                                    <div className="hidden md:flex flex-col">
                                                                        <p className="text-[#8189B0] text-[15px] font-bold">{teacher.userFullName.length > 35
                                                                            ? `${teacher.userFullName.slice(0, 45)}...`
                                                                            : teacher.userFullName}</p>
                                                                        <p className="text-[#8189B0] text-[15px] ">{teacher.userEmail.length > 35
                                                                            ? `${teacher.userEmail.slice(0, 45)}...`
                                                                            : teacher.userEmail}</p>
                                                                    </div>
                                                                    <div className="flex flex-col">
                                                                        <button
                                                                            onClick={() => {
                                                                                // console.log(teacher);
                                                                                const [grade, classNUmber] = teacher.assignedClass.split('-');
                                                                                let teacherObject = {
                                                                                    userFullName: teacher.userFullName,
                                                                                    userEmail: teacher.userEmail,
                                                                                    district: teacher.district,
                                                                                    school: teacher.school,
                                                                                    assignedClass: `${teacher.assignedClass}`,
                                                                                    mobile: teacher.contactNumber
                                                                                }
                                                                                localStorage.setItem("userSelected", JSON.stringify(teacherObject));
                                                                                navigate('/researcher/teacherprofile/view');
                                                                            }}
                                                                            className="bg-[#BBFFA3] text-black text-[13px] rounded-lg py-[4px] w-[110px] md:w-[130px]">{t('t207')}</button>
                                                                        {/* <button className="mt-[5px] bg-[#FFBEA3] text-black text-[13px] rounded-lg py-[3px] w-[110px] md:w-[130px]">Reset password</button> */}
                                                                    </div>
                                                                </div>

                                                            ))
                                                        }
                                                    </> :
                                                        <div className="mt-[10px] flex justify-center">
                                                            {
                                                                detailsFinal.district === "" && searchInputTeacher.trim() !== "" &&
                                                                <p className="text-[16px] text-black">{t('t201')}</p>
                                                            }
                                                            {
                                                                detailsFinal.district !== "" && searchInputTeacher.trim() !== "" &&
                                                                <p className="text-[16px] text-black">{t('t206')}</p>
                                                            }
                                                        </div>
                                                }
                                            </div>


                                            {
                                                filteredTeachers.length > 0 ?
                                                    <>
                                                        <div className="mt-[10px] hidden xl:grid grid-cols-3 pb-[50px] ml-[80px] mr-[70px]">
                                                            {
                                                                filteredTeachers.map((teacher, index) => (
                                                                    <div key={index} className="mt-[10px] flex items-center justify-between px-[20px] ml-[10px] mr-[5px] bg-[#F1F6FB] py-[10px] rounded-lg">
                                                                        <div className="2xl:hidden flex flex-col">
                                                                            <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] font-bold">{teacher.userFullName.length > 40
                                                                                ? `${teacher.userFullName.slice(0, 35)}...`
                                                                                : teacher.userFullName}</p>
                                                                            <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] ">{teacher.userEmail.length > 40
                                                                                ? `${teacher.userEmail.slice(0, 35)}...`
                                                                                : teacher.userEmail}</p>
                                                                        </div>
                                                                        <div className="hidden 2xl:flex flex-col">
                                                                            <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] font-bold">{teacher.userFullName.length > 45
                                                                                ? `${teacher.userFullName.slice(0, 45)}...`
                                                                                : teacher.userFullName}</p>
                                                                            <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] ">{teacher.userEmail.length > 45
                                                                                ? `${teacher.userEmail.slice(0, 45)}...`
                                                                                : teacher.userEmail}</p>
                                                                        </div>
                                                                        <div className="flex flex-col">
                                                                            <button
                                                                                onClick={() => {
                                                                                    const [grade, classNUmber] = teacher.assignedClass.split('-');
                                                                                    let teacherObject = {
                                                                                        userFullName: teacher.userFullName,
                                                                                        userEmail: teacher.userEmail,
                                                                                        district: teacher.district,
                                                                                        school: teacher.school,
                                                                                        assignedClass: `${teacher.assignedClass}`,
                                                                                        mobile: teacher.contactNumber
                                                                                    }
                                                                                    localStorage.setItem("userSelected", JSON.stringify(teacherObject));
                                                                                    navigate('/researcher/teacherprofile/view');
                                                                                }}
                                                                                className="bg-[#BBFFA3] text-black text-[13px] rounded-lg py-[4px] w-[110px]">{t('t207')}</button>
                                                                            {/* <button className="mt-[5px] bg-[#FFBEA3] text-black text-[13px] rounded-lg py-[3px] w-[110px]">Reset password</button> */}
                                                                        </div>
                                                                    </div>

                                                                ))
                                                            }
                                                        </div>
                                                    </> :
                                                    <div className="hidden xl:flex mt-[10px] justify-center w-full">
                                                        {
                                                            detailsFinal.district === "" && searchInputTeacher.trim() !== "" &&
                                                            <p className="text-[16px] text-black">{t('t201')}</p>
                                                        }
                                                        {
                                                            detailsFinal.district !== "" && searchInputTeacher.trim() !== "" &&
                                                            <p className="text-[16px] text-black">{t('t206')}</p>
                                                        }
                                                    </div>
                                            }

                                        </>
                                    }
                                </>
                        }
                    </>
            }


        </div >
    )
}

export default ResearcherManageData1;